import { useSelector } from '@xstate/react';

import { useMainMachine } from './useMainMachine';
import { AUTH_MACHINE_ID } from '../state';

export function useAuthMachine() {
  const { useSelector: useMainSelector } = useMainMachine();

  const authMachine = useMainSelector((state) => state.children[AUTH_MACHINE_ID]?.ref);

  const useAuthMachineSelector = (...props) => useSelector(authMachine, ...props);
  return { useAuthMachineSelector, authMachine };
}
